export default __webpack_public_path__ + "static/media/013-cheese.4cb86eb8.svg";